<template>
  <div class="lives-order-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <DatePicker type="daterange"
                      format="yyyy-MM-dd"
                      split-panels
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="订单号或手机号查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.phone"
                 clearable
                 placeholder="验票员工手机号..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_invoice"
                  clearable
                  style="width:100px"
                  placeholder="开发票">
            <Option v-for="item in invoiceList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportOrder()">导出团队订单</Button>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="12">
      <a style="margin-top:4px;"
         href="/template/智慧园区团体票.xlsx"
         class="f-r ml10">下载导入模版</a>
      <!-- <Button @click="showImportModel()" type="success" class="f-r">导入</Button> -->
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 团队详情弹出 -->
    <Drawer title="详情"
            v-model="showTeamModalStatus"
            width="800"
            scrollable
            :loading="loading"
            :mask-closable="false">
      <List>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">团队类型:</span>
                {{dataInfo.team_type==1?"社会团体":"学校"}}
              </label>
            </li>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">团队名称:</span>
                {{dataInfo.team_name}}
              </label>
            </li>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">团队人数:</span>
                {{dataInfo.team_num}}
              </label>
            </li>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">领队名称:</span>
                {{dataInfo.name}}
              </label>
            </li>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">领队电话:</span>
                {{dataInfo.phone}}
              </label>
            </li>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">领队身份证:</span>
                {{dataInfo.id_card}}
              </label>
            </li>
            <!-- <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">行程单号:</span>
                {{dataInfo.itinerary}}
              </label>
            </li>-->
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">备注:</span>
                {{dataInfo.mark}}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">团队成员:</span>
                <Table border
                       :columns="teamuser_list"
                       :data="tableTeamuserlist"
                       :loading="dataloading"></Table>
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">附加服务:</span>
                <Table border
                       :columns="service_list"
                       :data="tableServicelist"
                       :loading="dataloading"></Table>
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">接待员:</span>
                <Table border
                       :columns="receper_list"
                       :data="tableReceperlist"
                       :loading="dataloading"></Table>
              </label>
            </li>
          </template>
        </ListItem>
      </List>
    </Drawer>
    <!-- 导入的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importPark('leadInValidate')"
           :loading="loading">
      <Form :model="leadIn"
            ref="leadInValidate"
            :rules="leadInValidate"
            action="javascript:void(0)">
        <FormItem label="选择文件"
                  prop="filePath">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileList" ref="import-filesThree"></upload-question>-->
          <file-import v-model="leadIn.filePath"
                       :defaultList="fileList"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
    <!-- 更新状态的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="审核"
           @on-ok="updateStatus()"
           :loading="loading">
      <Form :model="review"
            action="javascript:void(0)">
        <FormItem label="支付金额"
                  prop="name">
          <Input v-model="review.total_price"
                 placeholder="请输入支付金额..."></Input>
        </FormItem>
        <FormItem label="支付状态">
          <Select v-model="review.pay_status"
                  clearable
                  filterable
                  placeholder="支付状态">
            <Option :value="0">未支付</Option>
            <Option :value="2">支付完成</Option>
          </Select>
        </FormItem>
        <FormItem label="备注"
                  label-position="top">
          <Input type="textarea"
                 v-model="review.admin_remark"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
      </Form>
    </Modal>
    <!-- 上传发票的弹出 -->
    <Modal v-model="showFapiaoModalStatus"
           title="上传发票"
           @on-ok="importfapiao()"
           :loading="loading">
      <!-- <Table border :columns="invoiceinfo" :data="tableinvoice" :loading="dataloading"></Table> -->

      <Form :model="fapiaoIn"
            action="javascript:void(0)">
        <Row>
          <Col span="12">
          <FormItem label="发票类型"
                    label-position="top">
            <Input v-model="invoiceData.invoice_type"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="发票抬头类型"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.title"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="单位名称"
                    label-position="top">
            <Input v-model="invoiceData.company"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="invoiceData.phone">
          <FormItem label="电话"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.phone"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12"
               v-if="invoiceData.shuihao">
          <FormItem label="税号"
                    label-position="top">
            <Input v-model="invoiceData.shuihao"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="invoiceData.address">
          <FormItem label="地址"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.address"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12"
               v-if="invoiceData.bank">
          <FormItem label="开户行"
                    label-position="top">
            <Input v-model="invoiceData.bank"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="invoiceData.account">
          <FormItem label="开户账号"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.account"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8"
               v-if="invoiceData.post_user">
          <FormItem label="收件人姓名"
                    label-position="top">
            <Input v-model="invoiceData.post_user"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="invoiceData.post_phone">
          <FormItem label="收件人电话"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.post_phone"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="invoiceData.post_address">
          <FormItem label="收件人地址"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="invoiceData.post_address"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="备注"
                  label-position="top"
                  v-if="invoiceData.mark">
          <Input v-model="invoiceData.mark"
                 type="textarea"
                 readonly></Input>
        </FormItem>
        <FormItem label="上传发票">
          <upload-thumb v-model="fapiaoIn.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"></upload-thumb>
        </FormItem>
        <FormItem label="请选择快递"
                  v-if="showLogisName">
          <Select :label-in-value="true"
                  v-model="loginst"
                  @on-change="perChange"
                  clearable
                  filterable
                  placeholder="选择快递">
            <Option v-for="item in selectLogistics"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="快递单号"
                  v-if="showLogisCode">
          <Input v-model="fapiaoIn.logistics_code"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
    <!-- 展示发票的弹出 -->
    <Modal v-model="showFapiao2ModalStatus"
           :loading="loading">
      <div>
        <div>
          <img :src="fapiaoIn2.thumb"
               style="width: 300px;height: 200px;" />
        </div>
        <div v-if="showLogis">
          <div>
            <span class="key_name">快递名称:</span>
            <span>{{fapiaoIn2.logistics_name}}</span>
          </div>
          <div>
            <span class="key_name">快递编号:</span>
            <span>{{fapiaoIn2.logistics_code}}</span>
          </div>
          <div>
            <span class="key_name">收件人:</span>
            <span>{{fapiaoIn2.post_user}}</span>
          </div>
          <div>
            <span class="key_name">收件电话:</span>
            <span>{{fapiaoIn2.post_phone}}</span>
          </div>
          <div>
            <span class="key_name">收件地址:</span>
            <span>{{fapiaoIn2.post_address}}</span>
          </div>
        </div>
        <div>
          <span class="key_name">备注:</span>
          <span>{{fapiaoIn2.mark}}</span>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import FileImport from "../common/fileimport";
import UploadThumb from "../common/thumb";
export default {
  name: "lives-order-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      exportLoading: false,
      showFapiaoModalStatus: false,
      showFapiao2ModalStatus: false,
      invoiceData: {},
      invoiceList: [
        { id: 0, name: "未开票" },
        { id: 1, name: "开票中" },
        { id: 2, name: "完成" }
      ],
      showLogisCode: false,
      showLogisName: false,
      showLogis: false,
      thumblist: [],

      loginst: [],
      selectLogistics: [],
      datetime: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      invoiceinfo: [
        {
          title: "发票抬头",
          key: "title",
          minWidth: 150
        },
        {
          title: "发票类型",
          key: "invoice_type",
          width: 90
        },
        {
          title: "单位名称",
          key: "company",
          minWidth: 150
        },
        {
          title: "税号",
          key: "shuihao",
          minWidth: 150
        },
        {
          title: "地址",
          key: "address",
          minWidth: 150
        },
        {
          title: "电话",
          key: "phone",
          minWidth: 150
        },
        {
          title: "开户行",
          key: "bank",
          minWidth: 150
        },
        {
          title: "开户账号",
          key: "account",
          minWidth: 150
        },
        {
          title: "备注",
          key: "mark",
          minWidth: 150
        },
        {
          title: "收件人姓名",
          key: "post_user",
          minWidth: 150
        },
        {
          title: "收件人电话",
          key: "post_phone",
          minWidth: 150
        },
        {
          title: "收件人地址",
          key: "post_address",
          minWidth: 150
        }
      ],
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "订单号",
          key: "order_sn",
          minWidth: 150
        },
        // {
        //   title: "支付订单号",
        //   key: "pay_order_num",
        //   minWidth: 150
        // },
        {
          title: "购买人",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.user != null ? params.row.user.username : ""
              )
            ]);
          }
        },
        {
          title: "场馆",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.ticket.venue != null
                  ? params.row.ticket.venue.title
                  : ""
              )
            ]);
          }
        },
        {
          title: "票",
          key: "name",
          width: 300,
          render: (h, params) => {
            var a = "";
            if (params.row.ticket != null && params.row.ticket.date_at != null)
              a = params.row.ticket.date_at;
            var c = "";
            if (params.row.ticket != null && params.row.ticket.end_at != null)
              c = a + " " + params.row.ticket.end_at;
            var d = "";
            if (
              params.row.ticket != null &&
              params.row.ticket.beigin_at != null
            )
              d = a + " " + params.row.ticket.beigin_at;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "开场时间：" + d
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "结束时间：" + c
              )
            ]);
          }
        },
        {
          title: "是否通票",
          key: "is_through_ticket",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.ticket.is_through_ticket == 1 ? "是" : "否"
              )
            ]);
          }
        },
        {
          title: "订单类型",
          key: "order_type",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.order_type == 1 ? "个人" : "团体")
            ]);
          }
        },
        // {
        //   title: "数量",
        //   key: "num",
        //   width: 150
        // },
        {
          title: "服务金额",
          key: "service_price",
          width: 150
        },
        {
          title: "总价",
          key: "total_price",
          width: 150
        },
        {
          title: "支付状态",
          key: "pay_status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.pay_status == 0
                  ? "未支付"
                  : params.row.pay_status == 1
                    ? "支付中"
                    : "已完成"
              )
            ]);
          }
        },
        {
          title: "支付时间",
          key: "pay_at",
          width: 150
        },
        {
          title: "订单状态",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 0 ? "取消" : "正常")
            ]);
          }
        },
        {
          title: "验票状态",
          key: "order_status",
          minWidth: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.order_status == 0 ? "未验票" : "已验票")
            ]);
          }
        },
        {
          title: "验票员工",
          key: "ticket_collector",
          minWidth: 150
        },
        {
          title: "开票类型",
          key: "invoice_type",
          minWidth: 150
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id); //团队
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showImportModel(params.row.id); //团队
                    }
                  }
                },
                "导入"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "0" || params.row.pay_status == "2"
                        ? "none"
                        : "inline-block"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row.id); //团队
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "1" &&
                        params.row.invoice_status == "1"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.kaipiao(params.row.order_sn, params.row.id); //团队
                    }
                  }
                },
                "开票"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "1" &&
                        params.row.invoice_status == "2"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.showfapiao(params.row.id); //团队
                    }
                  }
                },
                "查看发票"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      tableinvoice: [],
      tableTeamuserlist: [],
      tableServicelist: [],
      tableReceperlist: [],
      service_list: [
        {
          title: "名称",
          minWidth: 100,
          key: "name"
        }
      ],
      receper_list: [
        {
          title: "名称",
          minWidth: 100,
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.smartpark_receper == ""
                  ? ""
                  : params.row.smartpark_receper.name
              )
            ]);
          }
        }
      ],
      teamuser_list: [
        {
          title: "姓名",
          minWidth: 100,
          key: "name"
        },
        {
          title: "证件类型",
          minWidth: 100,
          key: "card_type",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.card_type == "1"
                  ? "身份证"
                  : params.row.card_type == "2"
                    ? "学生证"
                    : params.row.card_type == "3"
                      ? "护照"
                      : "其他"
              )
            ]);
          }
        },
        {
          title: "身份证",
          minWidth: 100,
          key: "card_no"
        },
        {
          title: "手机号",
          minWidth: 150,
          key: "phone"
        }
      ],
      dataInfo: {},
      logistics_id: "",
      logistics_name: "",
      review: {},
      fileList: [],
      leadIn: {
        filePath: ""
      },
      fapiaoIn: {
        thumb: ""
      },
      fapiaoIn2: {
        thumb: ""
      },
      showTeamModalStatus: false,
      showImportModalStatus: false,
      showEditInfoStatus: false,
      leadInValidate: {
        files: [
          {
            required: true,
            type: "string",
            message: "请选择上传文件",
            trigger: "change"
          }
        ]
      }
    };
  },
  // 组件
  components: {
    FileImport,
    UploadThumb
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getLogisticList();
  },
  methods: {
    getTableList: function () {
      this.$api.smartorder
        .list({
          page: this.pages.page,
          size: this.pages.size,
          order_type: 2
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    //团队
    detail (id) {
      this.title = "团队详情";
      this.showTeamModalStatus = !this.showTeamModalStatus;
      this.$api.smartorder.orderdetail({ id: id }).then(res => {
        this.dataInfo = res.result.orderinfo.orders_info;
        this.tableTeamuserlist = res.result.orderinfo.orders_team_user;
        this.tableServicelist = res.result.orderinfo.orders_services;
        this.tableReceperlist = res.result.orderinfo.smartpark_order_receper;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    changeDate (val) {
      this.datetime = val;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      var ps = {
        phone: this.formItem.phone,
        key: this.formItem.key,
        is_invoice: this.formItem.is_invoice,
        page: this.pages.page,
        size: this.pages.size,
        starttime: starttime,
        endtime: endtime,
        order_type: 2
      };
      this.$api.smartorder.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    perChange: function (index) {
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    //获取快递列表
    getLogisticList () {
      var params = {
        page: 1,
        size: 10000
      };
      this.$api.logistics.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.selectLogistics = res.result.list;
        }
      });
    },
    // 导入
    showImportModel: function (index) {
      this.orderid = index;
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileList = [];
      this.leadIn.filePath = "";
      // this.fileList.push({});
    },
    importPark (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (
            this.$refs["import-filesThree"].resList != undefined &&
            this.$refs["import-filesThree"].resList.length
          ) {
            this.leadIn.filePath = this.$refs[
              "import-filesThree"
            ].resList[0].url;
          } else {
            this.leadIn.filePath = "";
            this.$Message.error("请选择上传文件");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$nextTick(() => {
            this.loading = true;
          });
          this.leadIn.id = this.orderid;
          this.$api.smartorder.orderimport(this.leadIn).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showImportModalStatus = !this.showImportModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    edit: function (id) {
      this.orderid = id;
      this.showEditInfoStatus = !this.showEditInfoStatus;
    },
    // 添加
    updateStatus: function (name) {
      this.$api.smartorder
        .orderedit({
          id: this.orderid,
          pay_status: this.review.pay_status,
          total_price: this.review.total_price,
          admin_remark: this.review.admin_remark
        })
        .then(res => {
          if (res.code == 200) {
            this.showEditInfoStatus = false;
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    exportOrder () {
      this.exportLoading = true;
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      this.$api.smartorder
        .exportteamorder({
          starttime: starttime,
          endtime: endtime,
          phone: this.formItem.phone,
          key: this.formItem.key
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            // window.location.href = res.result;
          }
          this.exportLoading = false;
        });
    },
    // 开票
    kaipiao: function (index, id) {
      console.log("1111");
      this.fapiaoordernum = index;
      this.thumblist = new Array();
      this.fapiaoIn = {}
      this.logistics_id = null;
      this.logistics_name = null;
      this.loginst = null
      this.$api.smartorder
        .orderdetail({
          id: id
        })
        .then(res => {
          if (res.code == 200) {
            this.showFapiaoModalStatus = !this.showFapiaoModalStatus;
            if (
              res.result.orderinfo.orderinvoice.invoice_type == "纸质票" &&
              res.result.orderinfo.orderinvoice.post_address &&
              res.result.orderinfo.orderinvoice.post_address != undefined &&
              res.result.orderinfo.orderinvoice.post_address != ""
            ) {
              this.showLogisCode = true;
              this.showLogisName = true;
            } else {
              this.showLogisCode = false;
              this.showLogisName = false;
            }
            //开票信息
            this.tableinvoice = res.result.invoiceinfo;
            if (this.tableinvoice && this.tableinvoice != undefined && this.tableinvoice.length > 0) {
              this.invoiceData = this.tableinvoice[0]
            }
            console.log(this.tableinvoice);
          }
        });
    },
    importfapiao: function (index) {
      //封面图
      var fapiaothumb = "";
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.fapiaothumb = this.$refs["uploadthumb"].uploadList[0].url;
      }
      if (this.fapiaothumb == null || this.fapiaothumb == undefined || this.fapiaothumb == "") {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        this.$Message.error("请上传发票图片");
        return
      }

      this.$api.smartorder
        .shangchuaninvoice({
          order_sn: this.fapiaoordernum,
          dz_thumb: this.fapiaothumb,
          logistics_name: this.logistics_name,
          logistics_code: this.fapiaoIn.logistics_code
        })
        .then(res => {
          if (res.code == 200) {
            this.showFapiaoModalStatus = false;
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    showfapiao: function (index) {
      this.thumblist = new Array();
      this.$api.smartorder
        .orderdetail({
          id: index
        })
        .then(res => {
          if (res.code == 200) {
            this.showFapiao2ModalStatus = true;
            this.fapiaoIn2.mark = res.result.orderinfo.orderinvoice.mark;
            this.fapiaoIn2.thumb = res.result.orderinfo.orderinvoice.dz_thumb;
            if (
              res.result.orderinfo.orderinvoice.invoice_type == "纸质票" &&
              res.result.orderinfo.orderinvoice.post_address &&
              res.result.orderinfo.orderinvoice.post_address != undefined &&
              res.result.orderinfo.orderinvoice.post_address != ""
            ) {
              this.showLogis = true;
              this.fapiaoIn2.logistics_name =
                res.result.orderinfo.orderinvoice.logistics_name;
              this.fapiaoIn2.logistics_code =
                res.result.orderinfo.orderinvoice.logistics_code;
              this.fapiaoIn2.post_user =
                res.result.orderinfo.orderinvoice.post_user;
              this.fapiaoIn2.post_phone =
                res.result.orderinfo.orderinvoice.post_phone;
              this.fapiaoIn2.post_address =
                res.result.orderinfo.orderinvoice.post_address;
            } else {
              this.showLogis = false;
              this.fapiaoIn2.logistics_name = '';
              this.fapiaoIn2.logistics_code = '';
              this.fapiaoIn2.post_user = '';
              this.fapiaoIn2.post_phone = '';
              this.fapiaoIn2.post_address = '';
            }
          }
        });
    }
  }
};
</script>